interface Props {
  readonly iframeUrl: string;
  readonly address: string;
  readonly rooms: number;
  readonly livingArea: number;
  readonly landArea: number;
  readonly buildingYear: number;
}

export function PartnerEvaluationMapWidget(props: Props) {
  // TODO: Implement this

  return (
    <div className="h-full bg-white dark:bg-gray-800 drop-shadow-md rounded-xl overflow-hidden">
      <img
        src="/assets/demo/partner-evaluation-map.png"
        alt=""
        className="w-full aspect-16/9 border-b border-gray-200 dark:border-gray-700 object-cover"
      />
      <div className="p-3 md:p-8">
        <p>
          <strong>Adresse</strong>: {props.address}
        </p>
        <p>
          <strong>Zimmer</strong>: {props.rooms}
        </p>
        <p>
          <strong>Nutzfläche</strong>: {props.livingArea} m²
        </p>
        {props.landArea ? (
          <p>
            <strong>Grundstücksfläche</strong>: {props.landArea} m²
          </p>
        ) : null}
        <p>
          <strong>Baujahr</strong>: {props.buildingYear}
        </p>
      </div>
    </div>
  );
}
